module.exports = __webpack_public_path__ + "img/DSC_0037.ea2034c2.jpg";